import React from "react";
import DialDisplay from "./DialDisplay";
import NumericButtons from "./NumericButtons";
import FunctionButtons from "./FunctionButtons";
import { Student } from "../types/Student";

type DisplayStudent = Student & {
  attendance?: string | null;
  timestamp?: string | Date;
};

interface DialPadProps {
  studentNumber: string;
  onPadClick: (val: string) => void;
  onCheckin: () => void;
  onCheckout: () => void;
  onFaceRegister?: () => void;
  loading: boolean;
  matchedStudent?: DisplayStudent | null;
  resultStudent?: DisplayStudent | null;
  studentBoxOpacity?: number;
}

export default function DialPad({
  studentNumber,
  onPadClick,
  onCheckin,
  onCheckout,
  onFaceRegister,
  loading,
  matchedStudent,
  resultStudent,
  studentBoxOpacity = 1,
}: DialPadProps) {
  return (
    <div style={{
      width: "50vw",
      height: "100vh",
      background: "#f5f7fa",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingBottom: "40px",
      gap: "20px",
      boxShadow: "-2px 0 12px #eee",
      overflow: "hidden",
      boxSizing: "border-box"
    }}>
      <DialDisplay
        value={studentNumber}
        matchedStudent={matchedStudent}
        resultStudent={resultStudent}
        studentBoxOpacity={studentBoxOpacity}
      />
      
      <NumericButtons onButtonClick={onPadClick} />
      <FunctionButtons
        onCheckin={onCheckin}
        onCheckout={onCheckout}
        loading={loading}
        disabled={!studentNumber}
      />
    </div>
  );
}
